import createIcon from '../../createIcon';

/**
 * @component @name DirectionsCarFilled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguOTIgNS4wMUMxOC43MiA0LjQyIDE4LjE2IDQgMTcuNSA0SDYuNUM1Ljg0IDQgNS4yOSA0LjQyIDUuMDggNS4wMUwzIDExVjE5QzMgMTkuNTUgMy40NSAyMCA0IDIwSDVDNS41NSAyMCA2IDE5LjU1IDYgMTlWMThIMThWMTlDMTggMTkuNTUgMTguNDUgMjAgMTkgMjBIMjBDMjAuNTUgMjAgMjEgMTkuNTUgMjEgMTlWMTFMMTguOTIgNS4wMVpNNy41IDE1QzYuNjcgMTUgNiAxNC4zMyA2IDEzLjVDNiAxMi42NyA2LjY3IDEyIDcuNSAxMkM4LjMzIDEyIDkgMTIuNjcgOSAxMy41QzkgMTQuMzMgOC4zMyAxNSA3LjUgMTVaTTE2LjUgMTVDMTUuNjcgMTUgMTUgMTQuMzMgMTUgMTMuNUMxNSAxMi42NyAxNS42NyAxMiAxNi41IDEyQzE3LjMzIDEyIDE4IDEyLjY3IDE4IDEzLjVDMTggMTQuMzMgMTcuMzMgMTUgMTYuNSAxNVpNNS44MSA5TDYuODUgNkgxNy4xNEwxOC4xOCA5SDUuODFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsCarFilled = createIcon('DirectionsCarFilled', [
  [
    'path',
    {
      d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM7.5 15C6.67 15 6 14.33 6 13.5C6 12.67 6.67 12 7.5 12C8.33 12 9 12.67 9 13.5C9 14.33 8.33 15 7.5 15ZM16.5 15C15.67 15 15 14.33 15 13.5C15 12.67 15.67 12 16.5 12C17.33 12 18 12.67 18 13.5C18 14.33 17.33 15 16.5 15ZM5.81 9L6.85 6H17.14L18.18 9H5.81Z',
      key: 'bl2usx',
    },
  ],
]);

export default DirectionsCarFilled;
